import React from 'react'
import '../../Work-css/Sub_Icons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faHashtag, faShop, faSchool, faHouse, faCaretDown, faAddressCard, faAddressBook, faPersonCircleCheck, faSquarePollVertical, faMoneyBill, faComment, faGraduationCap, faPersonMilitaryPointing } from '@fortawesome/free-solid-svg-icons';

function School_portal_Sub({setSPBTN, setSuluhu, payementgateway, rock, ms, about, client, revs, contacts, school_portal, stude_P, real_estate_portal}) {
    const about_btn = () =>
        {
          about(true)
          setSPBTN(false)
        }
      
        const clients_btn = () =>
        {
          client(true)
        }
      
        const rev_btn = () =>
        {
          revs(true)
        }
      
        const contacts_btn = () =>
        {
          contacts(true)
        }
      
        const student_PBTN = () =>
        {
            stude_P(true)
        }
      
        const real_EST = () =>
        {
          real_estate_portal(true)
        }
      
        const school_PORT = () =>
        {
          school_portal(true)
        }
      
        const marketing_Space = () =>
        {
          ms(true)
          setSPBTN(false)
        }
      
        const guidance_CON = () =>
        {
           rock(true)
        }
      
        const payment_GW = () =>
        {
          payementgateway(true)
          setSPBTN(false)
        }
      
        const suluhu_PBTN = () =>
        {
          setSuluhu(true)
        }
  return (
    <div className='Sub_main'>
     <p className='sub_TT'>School Portal</p>
     <div>

           <div className='button_DIV'><FontAwesomeIcon icon={faAddressCard} className='icon_part' /><button onClick={about_btn}>About Us</button></div>
           <div className='button_DIV'><FontAwesomeIcon icon={faSquarePollVertical} className='icon_part' /><button onClick={marketing_Space}>Marketing /Student Promotion Space</button></div>
           <div className='button_DIV'><FontAwesomeIcon icon={faMoneyBill} className='icon_part' /><button onClick={payment_GW}>Payment GateWay</button></div>
                  
                

     </div>
    </div>
  )
}

export default School_portal_Sub
